import { BULLET_LIFETIME, TICKS } from "./config";
import { CollisionEvent } from "./CollisionEvent";
import { EndscreenElement } from "./EndscreenElement";
import { Entity } from "./Entity.ts";
import { EntityController } from "./EntityController.ts";
import { EntityElement } from "./EntityElement.js";
import { EntityRenderer } from "./EntityRenderer";
import { EntityRunner } from "./EntityRunner";
import { EntitySet } from "./EntitySet";
import { Score } from "./Score";
import { ScoreElement } from "./ScoreElement";
import { Vector2 } from "./Vector2";

export class Game extends AbortController {
  entities = new EntitySet();
  runner = new EntityRunner(this.entities);
  renderer = new EntityRenderer(this.entities);
  player = new Entity();
  controller = new EntityController(this.player, this);
  score = new Score();
  score_element = new ScoreElement(this.score);
  interval: number;

  constructor() {
    super();
    this.player.color = "#f0f8";
    this.player.text = ">";
    this.player.angle = Math.PI / 2;
    this.player.addEventListener("collision", this.endscreen.bind(this), this);
    this.entities.add(this.player);
    this.interval = setInterval(this.step.bind(this), 1000 / TICKS);
  }

  endscreen() {
    this.runner.abort();
    this.controller.abort();
    this.score.save();
    new EndscreenElement(this.score);
  }

  createBullet() {
    const bullet = new Entity();
    bullet.text = "=";
    bullet.radius = 0.2;
    bullet.color = "#0008";
    const angle_vector = Vector2.angle(this.player.angle);
    bullet.position = this.player.position.add(angle_vector);
    bullet.angle = this.player.angle;
    bullet.velocity = Vector2.angle(this.player.angle).mul(0.2);
    bullet.addEventListener("collision", <any>this.bulletHit.bind(this), this);
    this.entities.add(bullet);
    setTimeout(() => this.entities.delete(bullet), BULLET_LIFETIME);
  }

  bulletHit({ target, other }: CollisionEvent) {
    this.score.count++;
    this.entities.delete(target);
    this.entities.delete(other);
    const split_angle =
      other.position.sub(target.position).angle() - Math.PI / 2;
    if (other.radius > 0.7) {
      const a = other.clone();
      const b = other.clone();
      a.position = a.position.add(Vector2.angle(split_angle).mul(0.1));
      b.position = b.position.add(Vector2.angle(split_angle).mul(-0.1));
      a.radius = b.radius = other.radius * 0.6;
      this.entities.add(a);
      this.entities.add(b);
    }
  }

  step() {
    this.createRocks();
  }

  createRocks() {
    for (let i = this.entities.groups.rocks?.size || 0; i < 10; i++)
      this.createRock();
  }

  createRock() {
    const entity = new Entity();
    const distance = 5 + Math.random() * 5;
    const speed = Math.random() * 0.1;
    const delta = Vector2.randomAngle().mul(distance);
    entity.position = this.player.position.add(delta);
    entity.angle_velocity = (Math.random() - 0.5) * 0.1;
    entity.velocity = Vector2.randomAngle().mul(speed);
    entity.radius = 0.5 + Math.random() * 0.7;
    entity.group = "rocks";
    this.entities.add(entity);
  }

  abort() {
    super.abort();
    this.runner.abort();
    this.renderer.abort();
    clearInterval(this.interval);
  }
}
